import React from 'react';
import { Container} from './style.css'

const Content = (props) => {
    return ( 
        <Container bgColor={props.bgColor}>
            {props.children}
        </Container>
     );
}
 
export default Content;